import { useCallback, useMemo, useState } from "react";

import { getCheckedItems } from "@/utils/getCheckedItems";

const useCheckboxQuestion = (maxChosenOptions?: number) => {
    const [checked, setChecked] = useState<string[]>([]);

    const handleCheck = useCallback(
        (id: string) => {
            const items = getCheckedItems(id, checked);
            const maxChosenOpts = maxChosenOptions ?? items.length;

            if (maxChosenOpts < items.length) return;
            setChecked(items);
        },
        [checked, maxChosenOptions]
    );

    const isContinueDisabled = useMemo(
        () =>
            maxChosenOptions
                ? !checked?.length || checked?.length > maxChosenOptions
                : !checked?.length,
        [maxChosenOptions, checked]
    );

    const getIsChecked = useCallback((id: string) => checked.includes(id), [checked]);

    return {
        checked,
        handleCheck,
        handleBulkCheck: setChecked,
        getIsChecked,
        isContinueDisabled,
    };
};

export default useCheckboxQuestion;
